<template>
  <div class="form-group">
    <select class="form-select" id="nav-space" data-cy="space" name="space" v-model="selectedSpaceId" @change="onChange()">
      <option :value="spaceOption.id" v-for="spaceOption in spaces" :key="spaceOption.id">
        {{ spaceOption.name }}
      </option>
    </select>
  </div>
</template>
<script lang="ts" src="./select-space.component.ts"></script>

<style scoped>
/* Dans la navbar (flex, align-items: center), un margin-top décalait le select vers le bas.
   On le centre verticalement et on le laisse à une largeur raisonnable. */
.form-group {
  margin: 0;
}
</style>
